import React, { useState, useEffect } from 'react';
import { baseUrl, apiCommon, getUserAllData, apiCommonGet } from '../../Constants/index.js';
import { Decoder } from '../js/Decoder.js';
import { formatDate } from '../js/dateFormat.jsx';
import axios from 'axios';
import { toast, Bounce } from 'react-toastify';
import Swal from 'sweetalert2';
import { FaCircleMinus } from 'react-icons/fa6';
import { IoIosAddCircle } from 'react-icons/io';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
export default function AttachmentTable({
  reqId,
  action,
  rowData,
  onDocsRowsChange,
  moduleCode,
  formCode,
  dropdownAction,
  getAttachAction,
  confirm,
}) {
  let userAllData = getUserAllData();
  const token = localStorage.getItem('token');
  const [docTypeData, setDocTypeData] = useState([]);
  const [docsRows, setDocsRows] = useState([]);
  const [imgUrl, setImgUrl] = useState('');
  const [imgName, setImgName] = useState('');
  const [attachmentData, setAttachmentData] = useState(null);

  const [visible, setVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfName, setPdfName] = useState('');
  const [showPdf, setShowPdf] = useState(false);

  useEffect(() => {
    attachDropdownService();
    if (rowData !== null && action !== 'REF') {
      getAttachData(reqId);
    }
  }, [reqId, action]);

  // useEffect(() => {
  //     if (docsRows.length > 0) {
  //         onDocsRowsChange(docsRows);
  //     }
  // }, [docsRows]);
  useEffect(() => {
    onDocsRowsChange(docsRows);
  }, [docsRows]);

  // api call attachement dropdown
  const attachDropdownService = async () => {
    await axios
      .post(
        `${baseUrl}${apiCommon}GetDocumentConfigByFormCode`,
        {
          ModuleCode: moduleCode,
          FormCode: formCode,
          ...(moduleCode === 'InvoiceChecklist' && {
            ReferenceName: `${rowData?.RequestNumber}`,
            ID: `${rowData?.CriteriaID}`,
          }),
          ObjCommon: {
            LoggedInUserID: userAllData[0]?.loginUserId,
            Action: dropdownAction,
            CompanyID: userAllData[0]?.companyId,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(res => {
        const dt = res.data;
        if (res.status === 200 && dt.responseCode === '1') {
          const encryptData = Decoder(dt.responseDynamic);
          setDocTypeData(encryptData?.Table);
        }
      })
      .catch(err => {
        // setLoading(false);
      });
  };

  // api for get attachement list data by id
  const getAttachData = async id => {
    const module = moduleCode === 'InvoiceChecklist';
    await axios
      .post(
        `${baseUrl}${apiCommon}GetUploadedDocumentsList`,
        {
          ModuleCode: moduleCode,
          FormCode: formCode,
          ReferenceID: module ? `${rowData.CriteriaID}_${id}` : `${id}`,
          ObjCommon: {
            LoggedInUserID: userAllData[0]?.loginUserId,
            Action: getAttachAction,
            CompanyID: userAllData[0]?.companyId,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(res => {
        const dt = res.data;
        if (res.status === 200 && dt.responseCode === '1') {
          if (dt?.responseDynamic !== '') {
            const encryptData = Decoder(dt?.responseDynamic);
            setAttachmentData(encryptData?.Table[0]);
            const transformedData = encryptData?.Table?.map((item, index) => {
              return {
                id: index,
                values: [
                  moduleCode === 'SAP' ? item?.DocumentName : item?.DocumentID || 0,
                  moduleCode === 'SAP' ? item?.FileName : item?.OriginalFileName || '',
                  '',
                  item?.UploadedBy || '',
                  item?.CreationDate ? formatDate(item?.CreationDate) : '',
                  item?.Remarks || '',
                  item?.MappingID || 0,
                ],
              };
            });
            setDocsRows(transformedData);
          }
        }
      })
      .catch(err => {
        // setLoading(false);
      });
  };

  // api for delete attachment row
  const deleteAttachementService = async (id, rowId) => {
    await axios
      .post(
        `${baseUrl}${apiCommon}DocumentDelete`,
        {
          DMSID: `${id}`,
          ReferenceID: `${reqId}`,
          ObjCommon: {
            LoggedInUserID: userAllData[0]?.loginUserId,
            CompanyID: userAllData[0]?.companyId,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(res => {
        const dt = res.data;
        if (res.status === 200 && dt.responseCode === '1') {
          Swal.fire({
            text: dt.responseMessage,
            icon: 'success',
            allowOutsideClick: false,
            showConfirmButton: false,
            width: '25rem',
            timer: 2000,
          });
          const updatedDocsRows = docsRows.filter(row => row.id !== rowId);
          setDocsRows(updatedDocsRows);
        } else if (dt.responseCode === '0') {
          toast.error(dt.responseMessage, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: 'light',
            transition: Bounce,
          });
        }
      })
      .catch(err => {
        // setLoading(false);
      });
  };

  // function call add attachment
  const addDocsRows = () => {
    // const newDocsRows = { id: Date.now(), values: Array(6).fill('') };
    // setDocsRows([...docsRows, newDocsRows]);
    setDocsRows(prevRows => [...prevRows, { id: Date.now(), values: Array(6).fill('') }]);
  };

  const removeDocsRow = rowId => {
    let rowToRemove = docsRows.find(obj => obj.id === rowId);
    if (confirm) {
      Swal.fire({
        title: 'Are you sure?',
        // text: "You want to delete this attachment!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(result => {
        if (result.isConfirmed) {
          if (rowToRemove.values.length > 6) {
            deleteAttachementService(rowToRemove?.values[6], rowId);
          } else {
            const updatedRows = docsRows.filter(row => row.id !== rowId);
            setDocsRows(updatedRows);
            Swal.fire({
              text: 'Deleted Successfully',
              icon: 'success',
              allowOutsideClick: false,
              showConfirmButton: false,
              width: '25rem',
              timer: 2000,
            });
          }
        }
      });
    } else {
      if (rowToRemove.values.length > 6) {
        deleteAttachementService(rowToRemove?.values[6], rowId);
      } else {
        const updatedRows = docsRows.filter(row => row.id !== rowId);
        setDocsRows(updatedRows);
        Swal.fire({
          text: 'Deleted Successfully',
          icon: 'success',
          allowOutsideClick: false,
          showConfirmButton: false,
          width: '25rem',
          timer: 2000,
        });
      }
    }
  };

  const handleDocsInputChange = (id, column, value) => {
    const updatedDocsRows = docsRows.map(row => {
      if (row.id === id) {
        const newValues = [...row.values];
        if (column === 1 && value instanceof File) {
          // Create local preview URL
          const previewUrl = URL.createObjectURL(value);
          newValues[1] = value; // store file object
          newValues[2] = previewUrl; // store preview
        } else {
          newValues[column] = value;
        }

        return { ...row, values: newValues };
      }

      return row;
    });
    setDocsRows(updatedDocsRows);
  };

  const handleDownload = async key => {
    try {
      const response = await fetch(key === 'pdf' ? pdfUrl : imgUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      if (key === 'pdf') {
        link.download = pdfName;
      } else {
        if (imgName) {
          link.setAttribute('download', `${imgName}`);
        } else {
          link.download = imgUrl.split('=').pop() || 'image.jpg';
        }
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      // console.error(error);
    }
  };

  const handleShowImg = async (fileID, fileName, isPdf, isExcel, isDocx, url) => {
    if (!fileID) {
      try {
        const extension = isPdf ? 'pdf' : isExcel ? 'xlsx' : 'jpg'; // Change as needed
        // Check if file exists (you can customize this part based on your file serving logic)
        if (url?.startsWith('blob:')) {
          // Fetch the blob and trigger download
          const response = await fetch(url);
          const blob = await response.blob();

          const downloadUrl = window.URL.createObjectURL(blob);
          if (extension === 'pdf') {
            setPdfUrl(downloadUrl);
            setShowPdf(true);
            setPdfName(fileName);
            return;
          } else if (extension === 'xlsx') {
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `${fileName}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl); // Free memory
          } else {
            setVisible(true);
            setImgUrl(downloadUrl);
            setImgName(fileName);
          }
        }
      } catch (error) {
        console.error(error);
      }
      return;
    }

    // Continue with API call if FileID is available
    const fileCommonUrl = `${baseUrl}${apiCommonGet}ViewDocument?FileID=${fileID}&FileName=${fileName}`;
    const sapFileUrl = `${baseUrl}${apiCommonGet}ViewDocument?FileID=${fileID}&FileName=${fileName}&type=${attachmentData?.Type}`;
    const fileUrl = moduleCode === 'SAP' ? sapFileUrl : fileCommonUrl;
    if (isExcel || isDocx) {
      try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        const extension = isPdf ? 'pdf' : 'xlsx';
        const suggestedName = fileName || `document.${extension}`;

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', suggestedName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
      }
      return;
    } else if (isPdf) {
      try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        setPdfUrl(blobUrl);
        setShowPdf(true);
        setPdfName(fileName);
      } catch (error) {
        console.error(error);
      }
      return;

      // setPdfUrl(fileUrl);
      // setShowPdf(true);
      // setPdfName(fileName);
      // return;
    } else {
      // If it's an image, preview it
      setImgUrl(fileUrl);
      setVisible(true);
    }
  };

  const imgHeader = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        className="mb-5"
      >
        <h5>Document Viewer</h5>
        <Button
          type="button"
          label="Download"
          className="p-button-success"
          style={{
            borderRadius: '10px',
            padding: '0px 12px 2px 10px',
            fontSize: '17px',
          }}
          onClick={() => handleDownload('img')}
        />
      </div>
    );
  };
  return (
    <>
      <div className="attchment-table-section">
        <div className="row">
          <div className="col-md-12 matConsAdd-table-responsive">
            <div className="matConAdd-attch-table" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
              <table
                style={{
                  width: '1000px',
                  tableLayout: 'fixed',
                  minWidth: '100%',
                }}
              >
                <thead>
                  <tr className="matConList-header">
                    {action === 'VIEW' ? '' : <th style={{ width: '5%' }}>#</th>}
                    <th style={{ width: '15%' }}>
                      Document Type<span className="red">*</span>
                    </th>
                    <th style={{ width: '20%' }}>
                      File Name<span className="red">*</span>
                    </th>
                    <th style={{ width: '10%' }}>Preview</th>
                    <th style={{ width: '20%' }}>Uploaded By</th>
                    <th style={{ width: '15%' }}>Uploaded Date</th>
                    <th style={{ width: '20%' }}>Remarks</th>
                  </tr>
                </thead>
                {docsRows.length === 0 && action === 'VIEW' ? (
                  <tbody>
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center', fontSize: '16px' }}>
                        No attachment record
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {docsRows.map((row, index) => {
                      const fileName = typeof row.values[1] === 'string' ? row.values[1] : row.values[1]?.name;
                      const disableRow = row.values.length === 7;
                      const isPdf = fileName?.toLowerCase().endsWith('.pdf');
                      const isExcel = fileName?.toLowerCase().endsWith('.xlsx') || fileName?.toLowerCase().endsWith('.xls');
                      const isDocx = fileName?.toLowerCase().endsWith('.docx') || fileName?.toLowerCase().endsWith('.txt');
                      return (
                        <>
                          <tr key={row.id} className="matConList-row">
                            {action === 'VIEW' ? (
                              ''
                            ) : (
                              <td>
                                {index === 0 ? (
                                  <div className="matCon-add-remove-btn">
                                    <span>
                                      <FaCircleMinus
                                        onClick={() => removeDocsRow(row.id)}
                                        style={{
                                          color: 'red',
                                          fontSize: '17px',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  <div className="matCon-add-remove-btn">
                                    <span>
                                      <FaCircleMinus
                                        onClick={() => removeDocsRow(row.id)}
                                        style={{
                                          color: 'red',
                                          fontSize: '17px',
                                          cursor: 'pointer',
                                        }}
                                      />
                                    </span>
                                  </div>
                                )}
                              </td>
                            )}
                            {row.values?.slice(0, 6).map((value, columnIndex) => (
                              <td key={columnIndex}>
                                {columnIndex === 0 && docTypeData ? (
                                  <>
                                    {moduleCode === 'SAP' ? (
                                      <input
                                        type="text"
                                        className="matConAdd-input"
                                        value={value}
                                        onChange={e => handleDocsInputChange(row.id, columnIndex, e.target.value)}
                                        disabled
                                      />
                                    ) : (
                                      <select
                                        value={value}
                                        className="matConAdd-input"
                                        disabled={disableRow}
                                        onChange={e => handleDocsInputChange(row.id, columnIndex, e.target.value)}
                                      >
                                        <option value="">Select</option>
                                        {docTypeData.map((option, index) => (
                                          <option key={index} value={option?.DocumentID}>
                                            {option?.DocumentName}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  </>
                                ) : columnIndex === 1 ? (
                                  <>
                                    {disableRow ? (
                                      <div className="custom-file">
                                        <input
                                          type="text"
                                          className="matConAdd-input"
                                          value={value} // Show the value if the row is disabled
                                          onChange={e => handleDocsInputChange(row.id, columnIndex, e.target.value)}
                                          disabled={disableRow}
                                        />
                                      </div>
                                    ) : (
                                      <>
                                        {rowData?.uploadedExcel ? (
                                          <input
                                            type="text"
                                            className="matConAdd-input"
                                            value={rowData?.uploadedFile.name} // Display the uploaded file name
                                            disabled
                                          />
                                        ) : (
                                          <input
                                            type="file"
                                            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx"
                                            className="matConAdd-input"
                                            onChange={e => handleDocsInputChange(row.id, columnIndex, e.target.files[0])}
                                            aria-describedby="inputGroupFileAddon04"
                                            aria-label="Upload"
                                          />
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : columnIndex === 2 ? (
                                  <>
                                    {disableRow ? (
                                      <div
                                        style={{ textAlign: 'center' }}
                                        onClick={() => handleShowImg(row.values[6], row.values[1], isPdf, isExcel, isDocx)}
                                      >
                                        {isPdf ? (
                                          <i
                                            className="pi pi-file-pdf"
                                            style={{
                                              color: 'red',
                                              fontSize: '20px',
                                            }}
                                          ></i>
                                        ) : isExcel ? (
                                          <i
                                            className="pi pi-file-excel"
                                            style={{
                                              color: 'green',
                                              fontSize: '20px',
                                            }}
                                          ></i>
                                        ) : isDocx ? (
                                          <i
                                            className="pi pi-file-word"
                                            style={{
                                              color: 'blue',
                                              fontSize: '20px',
                                            }}
                                          ></i>
                                        ) : (
                                          <img
                                            src={`${baseUrl}${apiCommonGet}ViewDocument?FileID=${row.values[6]}`}
                                            alt="preview"
                                            style={{
                                              maxWidth: '100px',
                                              maxHeight: '70px',
                                            }}
                                          />
                                        )}
                                      </div>
                                    ) : (
                                      <div
                                        style={{ textAlign: 'center' }}
                                        onClick={() =>
                                          handleShowImg(
                                            row.values[6],
                                            typeof row.values[1] === 'string' ? row.values[1] : row.values[1]?.name,
                                            isPdf,
                                            isExcel,
                                            '',
                                            row.values[2]
                                          )
                                        }
                                      >
                                        {isPdf ? (
                                          <i
                                            className="pi pi-file-pdf"
                                            style={{
                                              color: 'red',
                                              fontSize: '20px',
                                            }}
                                          ></i>
                                        ) : isExcel ? (
                                          <i
                                            className="pi pi-file-excel"
                                            style={{
                                              color: 'green',
                                              fontSize: '20px',
                                            }}
                                          ></i>
                                        ) : (
                                          row.values[2] &&
                                          typeof row.values[2] === 'string' && (
                                            <img
                                              src={row.values[2]}
                                              alt="preview"
                                              style={{
                                                maxWidth: '100px',
                                                maxHeight: '70px',
                                              }}
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                  </>
                                ) : columnIndex === 3 || columnIndex === 4 ? (
                                  <input
                                    type="text"
                                    className="matConAdd-input"
                                    value={value}
                                    onChange={e => handleDocsInputChange(row.id, columnIndex, e.target.value)}
                                    disabled
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    className="matConAdd-input"
                                    value={value}
                                    onChange={e => handleDocsInputChange(row.id, columnIndex, e.target.value)}
                                    disabled={disableRow}
                                  />
                                )}
                              </td>
                            ))}
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                )}
                {action === 'VIEW' ? (
                  ''
                ) : (
                  <tfoot>
                    <tr>
                      <td colSpan="12">
                        <div className="add-attachment">
                          <p
                            onClick={addDocsRows}
                            style={{
                              fontSize: '14px',
                              marginLeft: '3px',
                              cursor: 'pointer',
                            }}
                          >
                            {' '}
                            <span>
                              {' '}
                              <IoIosAddCircle />
                            </span>{' '}
                            Add New Attachment
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        </div>
        <Dialog
          header={imgHeader}
          visible={visible}
          breakpoints={{ '960px': '90vw', '641px': '100vw' }}
          onHide={() => setVisible(false)}
          style={{ width: '50vw', height: 'fit-content' }}
          draggable={true}
          resizable={false}
          blockScroll={true}
        >
          <div className="data-table-body attach-dialog">
            <img
              src={imgUrl}
              alt="no image"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            />
          </div>
        </Dialog>

        {showPdf && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.6)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: '80%',
                height: '86%',
                background: '#fff',
                padding: '10px',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              {/* Custom Download Button - exactly overlapping the default PDF download icon */}
              <a
                href={pdfUrl}
                download={pdfName}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: '#000',
                  color: '#fff',
                  padding: '12px 14px',
                  textDecoration: 'none',
                  borderRadius: '0 0 0 8px',
                  display: 'flex',
                  alignItems: 'center',
                  zIndex: 10,
                  opacity: 0.95,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
              >
                <i className="pi pi-download" style={{ marginRight: 6 }}></i> Download {pdfName?.slice(0, 10)}
              </a>
              {/* Close Button - top left, so it doesn't overlap download */}
              <i
                className="pi pi-times"
                style={{
                  position: 'absolute',
                  top: '0px',
                  left: '0px',
                  fontSize: '1.2rem',
                  cursor: 'pointer',
                  zIndex: 11,
                  background: '#fff',
                  borderRadius: '0 0 8px 0',
                  padding: '4px 10px',
                }}
                onClick={() => setShowPdf(false)}
              />
              <iframe src={pdfUrl} title="PDF Preview" width="100%" height="100%" style={{ border: 'none' }}></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
